module.exports = __webpack_public_path__ + "img/Mover_Side_Right.8fc20222.svg";